import {
  BookingData,
  BookingDataDetails,
  BookingDataWithUpgradeInfo,
  BookingState,
  Cartridge,
  CartridgeStatus,
  CartridgeVariant,
  PriceRequestInfo,
  PriceRequestStep,
  References,
} from '@markant-platform/cartridge/model';
import { ApprovalStrategy, OrganizationBookingApprovalDetails } from '@markant-platform/shared/organization/model';
import { User } from '@markant-platform/shared/user/model';
import { MOCK_CARTRIDGE_PRODUCTS } from './mock-cartridge-products';
import {
  OrganizationDetailData,
  OrganizationStatus,
  OrganizationType,
  QualificationLevel,
  SalutationType,
  UserType,
} from 'data-model';

export const MOCK_BOOKING_DATA: BookingData = {
  id: '6458949f9406a05acf76cb0f',
  cartridgeId: '63908b0f40aab46a5c4bb46c',
  cartridgeVariantId: '1234e29544e9fd436c21be4f',
  cartridgeName: 'Cartridge Leistung-Prototyp',
  cartridgeVariantName: 'Leistung-Prototyp Variante 1',
  cartridgeVariantDescription: '<p>Beschreibung Variante 1</p>',
  organizationId: '63a56f5a704b744a2995513a',
  price: {
    currency: 'EUR',
    centAmount: 20000,
    priceModel: 'SUBSCRIPTION',
    billingPeriod: 'MONTHLY',
    hasToBeRequested: false,
    targetAudience: {
      organizationType: OrganizationType.DEALER,
      ezr: false,
    },
  },
  bookingDate: '2023-05-08T06:20:15.059Z',
  user: '63a56f5956a691042838befe',
  responsibleUserId: '63a56f5956a691042838bd0f',
  userFirstname: 'Lisa',
  userLastname: 'Testuser',
  responsibleUserFirstname: 'Max',
  responsibleUserLastname: 'Mustermann',
  organizationName: 'Super Testing GmbH',
  cancellationDate: '2023-11-08T06:20:15.059Z',
  bookingState: BookingState.TO_BE_CANCELLED,
  workflowFinishedAt: '2023-05-08T06:20:50.604Z',
  usagePeriodEndDate: null,
  lastModifiedAt: '2023-05-08T06:20:50.604Z',
  version: 3,
  bookingStartedAt: '2023-05-08T06:20:50.604Z',
  hasLegalDocument: true,
  serviceUpgradeState: null,
};

export const MOCK_BOOKING_DATA_DETAILS = {
  ...(MOCK_BOOKING_DATA as BookingDataDetails),
  platformBilling: true,
  upgradableCartridgeVariantIds: [],
  contractStartDate: null,
  serviceUpgradeState: 'UPGRADE_REQUEST_OPEN',
  serviceUpgradeRequestData: {
    cartridgeId: 'cartridge id',
    cartridgeVariantId: '1',
    type: 'UPGRADE_REQUEST',
    createdAt: '',
    createdBy: '',
    upgradeCompletedAt: '',
    version: 1,
  },
  blocked: false,
} as BookingDataWithUpgradeInfo;

export const MOCK_BOOKING_USER_DATA: User = {
  salutation: SalutationType.m,
  firstname: 'Thomas',
  lastname: 'Müller',
  email: 'thomas_mueller@example.com',
  language: 'de',
  userType: UserType.NATURAL,
  organizationMemberships: [
    {
      organizationId: 'test-id',
      organizationName: 'Adesso SE',
      userOrganizationStatus: 'ACTIVE',
    },
  ],
};

export const MOCK_BOOKING_ORGANIZATION_DETAILS_DATA: OrganizationDetailData = {
  id: '654z5ez45u45654',
  commercialRegister: '',
  commercialRegisterId: '',
  contact: '',
  contactMail: '',
  createdAt: '',
  naceCode: '',
  customerNumber: 1234567,
  paymentInformation: {
    iban: '',
    bic: '',
    bank: 'string',
  },
  phone: '',
  taxNumber: '',
  status: OrganizationStatus.ACTIVE,
  name: 'Adesso SE',
  gln: '1234567890123',
  address: {
    street: 'TestStr.',
    streetNumber: '123',
    zipCode: '12345',
    city: 'Berlin',
    countryCode: 'DE',
  },
  ezrCustomer: false,
  qualificationLevel: QualificationLevel.LEVEL_3,
  billingEmail: 'billing@testcompany.de',
  billingLanguageIsoCode: 'de-DE',
  bookingId: 'booking-id',
};

export const MOCK_ORGANIZATION_BOOKING_APPROVAL_DETAILS: OrganizationBookingApprovalDetails = {
  id: '654z5ez45u45654',
  approvalStrategy: ApprovalStrategy.BOOKING_ONLY,
  leadContext: 'Lead context',
  createdAt: '',
  phone: '1231242',
  taxNumber: '123124',
  status: OrganizationStatus.ACTIVE,
  name: 'Adesso SE',
  gln: '1234567890123',
  address: {
    street: 'TestStr.',
    streetNumber: '123',
    zipCode: '12345',
    city: 'Berlin',
    countryCode: 'DE',
  },
  ezrCustomer: false,
  qualificationLevel: QualificationLevel.LEVEL_3,
  billingEmail: 'billing@testcompany.de',
  billingLanguageIsoCode: 'de-DE',
  organizationType: OrganizationType.SUPPLIER,
  masterKin: 'master-kin-1234',
  crmId: 'crm-id-123',
};

export const MOCK_BOOKING_CARTRIDGE_VARIANT_DATA: CartridgeVariant = {
  variantId: '63637ba8ac1b7b353e22100d',
  name: 'Cartridge Variant Test',
  description: 'Descriptipon of Cartridge Variant Test.',
  longDescription: 'Long descriptipon of Cartridge Variant Test.',
  icon: '123',
  image: 'image',
  price: {
    currency: 'EUR',
    centAmount: 20000,
    priceModel: 'FIXED_PRICE',
    billingPeriod: 'NONE',
    hasToBeRequested: true,
    targetAudience: {
      organizationType: OrganizationType.DEALER,
      ezr: false,
    },
  },
  variantStatus: CartridgeStatus.ACTIVE,
  allowUiBooking: true,
  allowEcsSelfBooking: false,
  requireIntegrationProject: true,
  type: 'STANDARD',
  setUpCost: {
    currency: 'EUR',
    centAmount: 20000,
    targetAudience: {
      organizationType: OrganizationType.DEALER,
      ezr: false,
    },
  },
};

export const MOCK_BOOKING_CARTRIDGE_DATA: Cartridge = {
  id: '63637ba8ac1b7b353e22680d',
  name: 'Super Leistung 12345',
  longName: '',
  description: 'Ut wisi enim ad minim veniam, quis nostrud exerci tation et quasi architecto beatae vitae dicta sunt',
  longDescription:
    'quae ab illo inventore veritatis et quasi architecto beatae vitae dicta sunt, explicabo. Nemo enim ipsam voluptatem, quia voluptas sit, aspernatur aut odit aut fugit, sed quia consequuntur magni dolores eos, qui ratione voluptatem sequi nesciunt, neque porro quisquam est. quae ab illo inventore veritatis et quasi architecto beatae vitae dicta sunt, explicabo. Nemo enim ipsam voluptatem, quia voluptas sit, quae ab illo inventore veritatis et quasi architecto beatae vitae dicta sunt, explicabo. Nemo enim ipsam voluptatem, quia voluptas sit. quae ab illo inventore veritatis et quasi architecto beatae vitae dicta sunt, explicabo. Nemo enim ipsam voluptatem, quia voluptas sit, aspernatur aut odit aut fugit, sed quia consequuntur magni dolores eos, quae ab illo inventore veritatis et quasi architecto beatae vitae dicta sunt, explicabo. Nemo enim ipsam voluptatem, quia voluptas sit, aspernatur aut odit aut fugit, sed quia consequuntur magni dolores eos, quae ab illo inventore veritatis et quasi architecto beatae vitae dicta sunt, explicabo. Nemo enim ipsam voluptatem, quia voluptas sit, aspernatur aut odit aut fugit, sed quia consequuntur magni dolores eos, quae ab illo inventore veritatis et quasi architecto beatae vitae dicta sunt, explicabo. Nemo enim ipsam voluptatem, quia voluptas sit, aspernatur aut odit aut fugit, sed quia consequuntur magni dolores eos, quae ab illo inventore veritatis et quasi architecto beatae vitae dicta sunt, explicabo. Nemo enim ipsam voluptatem, quia voluptas sit, aspernatur aut odit aut fugit, sed quia consequuntur magni dolores eos, quae ab illo inventore veritatis et quasi architecto beatae vitae dicta sunt, explicabo. Nemo enim ipsam voluptatem, quia voluptas sit, aspernatur aut odit aut fugit, sed quia consequuntur magni dolores eos, quae ab illo inventore veritatis et quasi architecto beatae vitae dicta sunt, explicabo. Nemo enim ipsam voluptatem, quia voluptas sit, aspernatur aut odit aut fugit, sed quia consequuntur magni dolores eos, quae ab illo inventore veritatis et quasi architecto beatae vitae dicta sunt, explicabo. Nemo enim ipsam voluptatem, quia voluptas sit, aspernatur aut odit aut fugit, sed quia consequuntur magni dolores eos.',
  image: 'https://picsum.photos/300/300?random=1',
  variants: [MOCK_BOOKING_CARTRIDGE_VARIANT_DATA],
  status: CartridgeStatus.ACTIVE,
  remoteEntry: '',
  legalNoticeLinks: [],
  cartridgeGroupKey: 'PROTOTYPE',
  marketingInformation: [],
  cartridgeFeatures: [],
  serviceUpgradeState: null,
};

export const MOCK_BOOKING_REFERENCES: References = {
  customerCartridgeReferenceId: 'TEST_REFERENCE_ID',
  costCenter: 'TEST_COST_CENTER',
  otherReferences: 'OTHER',
};

export const MOCK_PRICE_REQUEST_INFO: PriceRequestInfo = {
  cartridge: MOCK_CARTRIDGE_PRODUCTS[0] as Cartridge,
  cartridgeVariant: MOCK_CARTRIDGE_PRODUCTS[0].variants?.at(0),
  questions: {
    Test: '3',
  },
  step: PriceRequestStep.CONTACT,
};
